import { create } from 'zustand';

interface HeaderState {
  selectedOption: string;
  setSelectedOption: (option: string) => void;
}

const useHeaderStore = create<HeaderState>((set) => ({
  selectedOption: '',
  setSelectedOption: (option: string) => set({ selectedOption: option }),
}));

export default useHeaderStore;
